import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'react-bootstrap';
import ConditionalComponent from './ConditionalComponent';

const TableModalComponent = ({
  title,
  isVisible,
  isTableVisible,
  onHide,
  tableHeaders,
  tableRows,
  beforeTableChildren,
  afterTableChildren
}) => (
  <Modal show={isVisible} onHide={onHide} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {beforeTableChildren || null}
      <ConditionalComponent condition={isTableVisible}>
        <Table bordered condensed hover>
          <thead>
            <tr>
              {tableHeaders.map((header, index) => <th key={index}>{header}</th> )}
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </Table>
      </ConditionalComponent>
      {afterTableChildren || null}
    </Modal.Body>
  </Modal>
);

TableModalComponent.propTypes = {
  title: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  isTableVisible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  tableHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
  tableRows: PropTypes.any.isRequired,
  beforeTableChildren: PropTypes.any,
  afterTableChildren: PropTypes.any
};

export default TableModalComponent;


// WEBPACK FOOTER //
// src/Components/TableModalComponent.jsx